<template>
    <form class="space-y-4" @submit.prevent>
        <div>
            <label class="block text-gray-700 mb-1">Name</label>
            <input
                type="text"
                class="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring focus:border-blue-300"
                v-model="state.form.name.value" v-bind:class="{'border-red-400': state.form.name.error}" @input="handleInput('name')"
            />
            <div v-if="state.form.name.error" class="text-red-400">
                {{ state.form.name.error }}
            </div>
        </div>
        <Button
            class="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600 transition"
            @click="doSignup" :loading="state.loading" :disabled="state.formErrors"
        >
            Play as Guest
        </Button>
    </form>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { api } from '@/utils/api';
import { notify } from '@kyvg/vue3-notification';
import Button from '@/components/Button.vue';

const emit = defineEmits(['success']);

const baseURL = ref(baseUrl);

const state = reactive({
    loading: false,
    form: {
        guest: {
            value: true
        },
        name: {
            label: 'Name',
            value: '',
            required: true,
            error: false
        },
    },
    formErrors: false,
    errors: []
})

const missingRequiredFields = computed(() => {
    const missingFields = [];

    for (const field in state.form) {
        const formField = state.form[field];

        if (formField.required && !formField.value) {
            missingFields.push(field);
        }
    }

    return missingFields;
});

const handleInput = (field) => {
    const formField = state.form[field];

    if (!formField) {
        return;
    }

    if (formField.error && formField.value) {
        formField.error = false;
    }

    if (missingRequiredFields.value.length === 0) {
        state.formErrors = false;
    }
};

const doSignup = () => {
    // Reset any form error messages
    for(const field in state.form) {
        if(state.form[field].error) {
            state.form[field].error = false;
        }
    }

    if(missingRequiredFields.value.length > 0) {
        missingRequiredFields.value.forEach(missingField => {
            state.form[missingField].error = 'Please provide a ' + state.form[missingField].label;
        });

        state.formErrors = true;

        return;
    }

    state.loading = true;

    const params = {};
    for(const field in state.form) {
        params[field] = state.form[field].value
    }

    api({
        method: 'POST',
        endpoint: 'api/users',
        params: params,
        successCallback: (apiResponse) => {
            emit('success', apiResponse.data.data);
        },
        errorCallback: (apiResponse) => {
            apiResponse.errors.forEach(error => {
                notify({
                    title: "Validation error",
                    text: error.message,
                    group: "danger",
                    duration: 10000,
                    ignoreDuplicates: true
                });
            })

            state.formErrors = true;
            state.loading = false;
        }
    });
}

</script>
